import { createActionGroup, props } from "@ngrx/store";
import { Currency, Operation } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

// **************************************************************************
// CURRENCIES ACTIONS
// CRUD actions only - data loading uses global store
// **************************************************************************
export const CurrenciesActions = createActionGroup({
    source: "Super User / Currencies",
    events: {
        "Update Currency": props<{ request: Operation[]; id: number }>(),
        "Update Currency Success": props<{ response: Currency[]; toastKey: string }>(),
        "Update Currency Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
